import Vue from 'vue'
import cloudinary from 'cloudinary-core'
import moment from 'moment'
import { isObject, compact } from 'lodash'
import DefaultValues from '@/mixins/DefaultValues.js'
import store from '../services/store'

Vue.filter('monthName', (value) => {
  const MONTHS_NAME = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ]
  return MONTHS_NAME[value]
})

Vue.filter('prettyPrice', (value) => {
  if (!value) return value
  return value.toLocaleString(undefined, {
    maximumFractionDigits: 2
  })
})

Vue.filter('prettyAmount', (value) => {
  let currency = '€'
  if (store && store.state && store.state.configs && store.state.configs.CURRENCY === 'MAD') {
    currency = store.state.configs.CURRENCY
  }
  if (!value) return value
  let amount = value.toString()
  if (amount.length > 3) {
    amount = amount.split('').slice(0, amount.length - 3).join('')
    return `${Number(amount).toLocaleString(undefined, {maximumFractionDigits: 2})}k ${currency}`
  } else {
    return `${Number(amount)} ${currency}`
  }
})

Vue.filter('prettyPhone', (value) => {
  if (!value) return 'NC'
  return value.toString().match(/\d/ig).map((e, i) => i % 2 ? e : ` ${e}`).join('')
})

Vue.filter('prettyInlineAddress', (value) => {
  if (!value) return 'NC'
  return compact([value.line1, `${value.zip_code} ${value.city}`, value.country]).join(', ')
})

Vue.filter('round', (value, decimal = 2) => {
  return Number(value.toFixed(decimal))
})

const cl = cloudinary.Cloudinary.new({
  cloud_name: 'batiment-b'
})

Vue.filter('avatar', (value) => {
  let cloudinaryId
  if (isObject(value)) cloudinaryId = value.cloudinary_id
  else cloudinaryId = value
  return cl.url(cloudinaryId, {
    height: 100,
    width: 100,
    crop: 'fill',
    gravity: 'face',
    quality: 'auto',
    fetchFormat: 'auto'
  })
})

Vue.filter('avatarHeader', (value) => {
  let cloudinaryId
  if (isObject(value)) cloudinaryId = value.cloudinary_id
  else cloudinaryId = value
  return cl.url(cloudinaryId, {
    height: 100,
    width: 100,
    crop: 'fill',
    gravity: 'face',
    quality: 'auto',
    fetchFormat: 'auto',
    dpr: '2.0'
  })
})

Vue.filter('avatarBig', (value) => {
  let cloudinaryId
  if (isObject(value)) cloudinaryId = value.cloudinary_id
  else cloudinaryId = value
  return cl.url(cloudinaryId, {
    height: 200,
    width: 200,
    crop: 'fill',
    gravity: 'face',
    dpr: '2.0',
    quality: 'auto',
    fetchFormat: 'auto'
  })
})

Vue.filter('smallImage', (value) => {
  let cloudinaryId
  if (isObject(value)) cloudinaryId = value.cloudinary_id
  else cloudinaryId = value
  return cl.url(cloudinaryId, {
    height: 600,
    width: 800,
    crop: 'fill',
    quality: 'auto',
    fetchFormat: 'auto'
  })
})

Vue.filter('cloudinary', (value, conf) => {
  let cloudinaryId
  Object.assign(conf, {quality: 'auto', fetchFormat: 'auto'})
  if (isObject(value)) cloudinaryId = value.cloudinary_id
  else cloudinaryId = value
  return cl.url(cloudinaryId, conf)
})

Vue.filter('dtFormat', (value, format) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format(format)
  } else {
    return null
  }
})

Vue.filter('prettyDatetime', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('DD/MM HH:mm')
  } else {
    return null
  }
})

Vue.filter('prettyFullDatetime', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('DD/MM/YY HH:mm')
  } else {
    return null
  }
})

Vue.filter('prettyDate', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('LL')
  } else {
    return null
  }
})

Vue.filter('smallDate', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('DD/MM')
  } else {
    return null
  }
})

Vue.filter('date', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('DD/MM/YYYY')
  } else {
    return null
  }
})

Vue.filter('prettyTime', (value) => {
  let d = moment(value)
  if (value && d.isValid()) {
    return d.format('HH:mm')
  } else {
    return null
  }
})

Vue.filter('prettyTrimestre', (value) => {
  if (value) {
    let year = value.toString().slice(0, 4)
    let trim = value.toString().slice(4, 5)
    return `T${trim} ${year}`
  }
})

Vue.filter('prettyTrimestreLong', (value) => {
  if (value) {
    let year = value.toString().slice(0, 4)
    let trim = value.toString().slice(4, 5)
    return `${trim}${trim === 1 ? 'er' : 'e'} trim. ${year}`
  }
})

Vue.filter('cap', (value) => {
  if (value) {
    return value.charAt(0).toUpperCase() + value.slice(1)
  }
})
Vue.filter('uppercase', (value) => {
  if (value) {
    return value.toUpperCase()
  }
})

Vue.filter('truncate', (value, limit = 30) => {
  if (value) {
    return value && value.length && value.length > limit ? value.substring(0, limit) + '...' : value
  }
})

Vue.filter('truncateShort', (value) => {
  if (value && value.length) {
    let values = value.split(' ')
    return values.map(v => {
      return v.length > 6 ? v.substring(0, 6) + '.' : v
    }).join(' ')
  }
})

Vue.filter('pluralize', (value, pluralize = false) => {
  if (value && pluralize) {
    if (['s', 'x'].includes(value[value.length])) {
      return value
    } else return value + 's'
  } else return value
})

Vue.filter('trimestre', (value) => {
  value = value.toString()
  let trimestre = value.slice(-1)
  let year = value.substring(0, 4)
  return `${year}-T${trimestre}`
})

Vue.filter('variation', (oldVal, newVal) => {
  if (oldVal === 0 || newVal === 0) {
    return null
  }
  let delta = newVal / oldVal
  delta = delta * 100
  return Math.round(delta)
})

Vue.filter('taxList', (value) => {
  return value.map(x => DefaultValues.data().taxDispositifsData[x].label).join(', ')
})

Vue.filter('timeDelta', (value) => {
  let d = moment(value)
  let delta = moment().diff(d, 'minutes')
  if (delta < 2) {
    return 'Il y a quelques instants'
  } else if (delta < 60) {
    return `Il y a ${delta} minutes`
  } else if (delta < 1440) {
    delta = moment().diff(d, 'hours')
    return `Il y a ${delta} heures`
  } else {
    delta = moment().diff(d, 'days')
    return `Il y a ${delta} jours`
    // return d.format('DD/MM HH:mm')
  }
})

Vue.filter('extension', (fileName) => {
  return fileName.substr(fileName.lastIndexOf('.') + 1)
})

Vue.filter('isImage', (extension) => {
  return ['jpg', 'png', 'gif'].includes(extension)
})

Vue.filter('isPdf', (extension) => {
  return ['pdf'].includes(extension)
})

Vue.filter('smallName', (val) => {
  if (typeof val === 'string' && val.length > 1) {
    let name = val.split(' ')
    return `${name[0][0]}. ${name[1]}`
  } else {
    return val
  }
})

Vue.filter('tva', (priceHT, priceTTC) => {
  // need to pass priceTTC like that : {{ priceHT | tva(priceTTC) }}
  return (priceTTC - priceHT) * 100 / priceHT
})



// WEBPACK FOOTER //
// ./src/utils/DefaultFilters.js